import type { ReactNode } from "react";

/**
 * "Operating as: X / Target org: Y" amber banner used at the top of mode panels
 * that scope themselves to a target org + role (Admin, LocationTools, ...). One
 * shared primitive instead of three near-identical inlined copies; see
 * `docs/planning/container_padding_pass.md` \u00a7K + commit history.
 *
 * Renders nothing if both `roleLabel` and `orgName` are falsy \u2014 makes it safe to
 * mount unconditionally.
 */
export function OperatingAsBanner(props: {
  roleLabel: string | null | undefined;
  orgName: string | null | undefined;
  rightSlot?: ReactNode;
}) {
  if (!props.roleLabel && !props.orgName) return null;
  return (
    <div className="rounded-xl border border-amber-300 dark:border-amber-800/80 bg-amber-50 dark:bg-amber-950/30 px-4 py-3 text-xs sm:text-sm text-amber-900 dark:text-amber-100/95 flex flex-wrap items-center justify-between gap-2">
      <div className="font-semibold">Operating as: {props.roleLabel ?? "User"}</div>
      <div className="flex items-center gap-2">
        <span className="text-amber-800 dark:text-amber-200/90">
          Target org: <span className="font-semibold">{props.orgName ?? "Unknown org"}</span>
        </span>
        {props.rightSlot}
      </div>
    </div>
  );
}
